<template>
  <div :class="['accordion-item', { 'accordion-item--open': isOpen }]">
    <div class="accordion-item__top title title--5" @click="toggle">
      <slot name="icon"></slot>
      <slot name="title"></slot>
    </div>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div v-show="isOpen" class="accordion-item__content">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { initializeLozad } from '../../partials/_lozad.js';

export default {
  props: {
    openOnLoad: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isOpen = ref(false)

    const toggle = () => {
      isOpen.value = !isOpen.value
    }

    const beforeEnter = (el) => {
      el.style.height = '0'
    }
    const enter = (el) => {
      el.style.height = el.scrollHeight + 'px'
    }
    const beforeLeave = (el) => {
      el.style.height = el.scrollHeight + 'px'
    }
    const leave = (el) => {
      el.style.height = '0'
    }

    onMounted(() => {
      isOpen.value = props.openOnLoad
      initializeLozad();
    })

    return {
      isOpen,
      toggle,
      beforeEnter,
      enter,
      beforeLeave,
      leave,
    }
  },
}
</script>